/**
 * Balterley PDP Tabs Controller
 * - Desktop: 3-column grid (Description | Specification | Essential Extras), all open. Reviews hidden via CSS.
 * - Mobile: 4 accordions (Description, Specification, Reviews, Essential Extras). Desc+Spec closed, Extras open.
 * - Reviews modal: clicking Trustpilot widget in product-info opens a modal.
 */
(function () {
  var container = document.querySelector('.cc-product-details .product-details__block');
  if (!container) return;

  var isDesktop = window.innerWidth >= 1024;

  // 1. Tag each disclosure with data-tab-name
  var titleMap = {
    'Description': 'description',
    'Reviews': 'reviews',
    'Specification': 'specification',
    'Essential Extras': 'extras'
  };

  container.querySelectorAll('details-disclosure').forEach(function (el) {
    var titleEl = el.querySelector('.disclosure__title');
    if (titleEl) {
      var name = titleMap[titleEl.textContent.trim()];
      if (name) el.setAttribute('data-tab-name', name);
    }
  });

  function byName(name) {
    return container.querySelector('details-disclosure[data-tab-name="' + name + '"]');
  }

  function openTab(el) {
    if (!el) return;
    var d = el.querySelector('details');
    if (d) {
      d.setAttribute('open', '');
      var p = d.querySelector('.disclosure__panel');
      if (p) p.style.height = 'auto';
    }
  }

  function closeTab(el) {
    if (!el) return;
    var d = el.querySelector('details');
    if (d) d.removeAttribute('open');
  }

  // 2. Open/close tabs based on viewport
  if (isDesktop) {
    openTab(byName('description'));
    openTab(byName('specification'));
    openTab(byName('extras'));
    // Reviews hidden via CSS: .cc-product-details details-disclosure:has(.custom-reviews) { display: none }
  } else {
    closeTab(byName('description'));
    closeTab(byName('specification'));
    closeTab(byName('reviews'));
    openTab(byName('extras'));
  }

  // 3. Reviews modal
  var modal = document.createElement('div');
  modal.id = 'reviews-modal';
  modal.style.cssText = 'display:none;position:fixed;top:0;left:0;right:0;bottom:0;z-index:9999;background:rgba(0,0,0,0.5);justify-content:center;align-items:center;';

  var inner = document.createElement('div');
  inner.style.cssText = 'background:#fff;max-width:800px;width:90%;max-height:80vh;overflow-y:auto;border-radius:8px;padding:30px;position:relative;';

  var closeBtn = document.createElement('button');
  closeBtn.style.cssText = 'position:absolute;top:12px;right:16px;background:none;border:none;font-size:24px;cursor:pointer;';
  closeBtn.setAttribute('aria-label', 'Close');
  closeBtn.textContent = '\u00D7';
  closeBtn.addEventListener('click', function () { modal.style.display = 'none'; });

  var heading = document.createElement('h2');
  heading.style.cssText = 'margin:0 0 20px;';
  heading.textContent = 'Reviews';

  // Get product SKU and name from the page for Trustpilot
  var skuEl = document.querySelector('[data-balterley-sku]') || document.querySelector('.product-sku');
  var productSku = skuEl ? skuEl.textContent.trim() : '';
  var titleEl = document.querySelector('.product-info h1, .product-title');
  var productName = titleEl ? titleEl.textContent.trim() : '';

  var tpWidget = document.createElement('div');
  tpWidget.className = 'trustpilot-widget';
  tpWidget.setAttribute('data-locale', 'en-GB');
  tpWidget.setAttribute('data-template-id', '5717796816f630043868e2e8');
  tpWidget.setAttribute('data-businessunit-id', '662bb0adc93349f5b711c840');
  tpWidget.setAttribute('data-style-height', '600px');
  tpWidget.setAttribute('data-style-width', '100%');
  tpWidget.setAttribute('data-theme', 'light');
  tpWidget.setAttribute('data-review-languages', 'en');
  if (productSku) tpWidget.setAttribute('data-sku', productSku);
  if (productName) tpWidget.setAttribute('data-name', productName);
  tpWidget.setAttribute('data-no-reviews', 'show');
  tpWidget.setAttribute('data-fullwidth', 'true');

  var tpLink = document.createElement('a');
  tpLink.href = 'https://uk.trustpilot.com/review/www.balterley.co.uk';
  tpLink.target = '_blank';
  tpLink.rel = 'noopener';
  tpLink.textContent = 'Trustpilot';
  tpWidget.appendChild(tpLink);

  inner.appendChild(closeBtn);
  inner.appendChild(heading);
  inner.appendChild(tpWidget);
  modal.appendChild(inner);
  document.body.appendChild(modal);

  modal.addEventListener('click', function (e) {
    if (e.target === modal) modal.style.display = 'none';
  });

  // Add click overlays to Trustpilot widgets in product-info
  // Trustpilot replaces widget content with iframes (z-index 99) after init,
  // so we wait for iframes to appear, then add overlay on top.
  function addTpOverlays() {
    document.querySelectorAll('.product-info .trustpilot-widget').forEach(function (w) {
      if (w.dataset.modalOverlay) return; // already done
      var iframes = w.querySelectorAll('iframe');
      if (iframes.length === 0) return; // Trustpilot hasn't initialized yet
      w.dataset.modalOverlay = '1';
      w.style.position = 'relative';
      w.style.cursor = 'pointer';
      var overlay = document.createElement('div');
      overlay.style.cssText = 'position:absolute;top:0;left:0;right:0;bottom:0;z-index:200;cursor:pointer;';
      overlay.addEventListener('click', function () {
        modal.style.display = 'flex';
        // Trustpilot needs the element visible before it can render
        setTimeout(function () {
          if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(tpWidget);
          }
        }, 100);
      });
      w.appendChild(overlay);
    });
  }
  // Try immediately, then retry after Trustpilot initializes
  addTpOverlays();
  setTimeout(addTpOverlays, 3000);
  setTimeout(addTpOverlays, 6000);

  // 4. Hide EasySpecs everywhere (replaced by our spec snippet)
  var easySpecs = document.getElementById('easyspecs-container-custom');
  if (easySpecs) easySpecs.style.display = 'none';
})();
